module.exports = __webpack_public_path__ + "static/media/js.6dc6899a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/js.png
// module id = 616
// module chunks = 147